import {
  Component,
  OnInit,
  HostBinding
} from '@angular/core';
import { MatDialogRef } from '@angular/material';


@Component({
  selector: 'awair-positive-confirm',
  templateUrl: './positive-confirm.component.html',
  styleUrls: ['./positive-confirm.component.scss']
})

export class PositiveConfirmComponent implements OnInit {
  @HostBinding('style.display') display = 'block';
  @HostBinding('style.max-width') width;

  header: string;
  subHeader: string;
  btnText: string;

  constructor(private myDialogRef: MatDialogRef<PositiveConfirmComponent>) { }

  ngOnInit() {
  }

  cancel(): void {
    this.myDialogRef.close({ isConfirmed: false });
  }

  confirm(): void {
    this.myDialogRef.close({ isConfirmed: true });
  }

}
